import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { RiDeleteBinFill } from "react-icons/ri";

interface ChoiceButtonsProps {
  isCorrectAnswer: boolean;
  handleToggleIsCorrectAnswer: (e: React.MouseEvent<HTMLButtonElement>, index: number) => void;
  handleRemoveChoice: (index: number) => void;
  index: number;
  isShown: boolean;
  isLiveMode?: boolean;
  position?: "1" | "2" | "3";
}

export function ChoiceButtons({
  isCorrectAnswer,
  handleToggleIsCorrectAnswer,
  index,
  isLiveMode = false,
  position = "1",
}: ChoiceButtonsProps) {
  const positionMap = {
    "1": "top-1 left-1",
    "2": "top-2 left-2",
    "3": "top-3 left-3",
  } as const;

  const positionClass = positionMap[position];

  return (
    <div
      className={`absolute cursor-pointer text-xl ${positionClass} ${isLiveMode && "pointer-events-none"}`}
    >
      <button
        type="button"
        onClick={(e) => handleToggleIsCorrectAnswer(e, index)}
        className={`absolute z-[99] ${isCorrectAnswer || isLiveMode ? "pointer-events-none" : "cursor-pointer"}   bg-white rounded-md border-2 shadow-md text-xl p-0.5 transition-all duration-200 hover:scale-110 ${
          isCorrectAnswer ? "border-success-500" : "border-slate-300"
        }`}
      >
        {isCorrectAnswer ? (
          <MdCheckBox className="text-success-500" />
        ) : (
          <MdCheckBoxOutlineBlank className="text-slate-400" />
        )}
      </button>

      {/* {isShown && (
        <button
          type="button"
          disabled={isCorrectAnswer}
          onClick={() => handleRemoveChoice(index)}
          className="
                          bg-white text-error rounded-full shadow-md border-2 border-white
                          cursor-pointer transition-transform hover:scale-110
                          disabled:text-gray-500 disabled:cursor-not-allowed
                          disabled:hover:scale-100
                        "
        >
          <RiDeleteBinFill />
        </button>
      )} */}
    </div>
  );
}
